import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  Typography,
  Box,
} from '@mui/material';

interface AddNewTreeNodePopupProps {
  open: boolean;
  onClose: () => void;
  availablePOS: {
    id: number;
    uuid: string;
    title: string;
    level: number;
    updatable: boolean;
    hasOpenShift: boolean | null;
    warehouseName: string | null;
    warehouseId: number | null;
    orderId: number | null;
    children: [];
    posId: number | null;
    key: number;
  }[];
}

const AddNewTreeNodePopup: React.FC<AddNewTreeNodePopupProps> = ({ open, onClose, availablePOS }) => {
  const [selectedType, setSelectedType] = useState<string>('');
  const [selectedPOS, setSelectedPOS] = useState<string>('');

  const handleAdd = () => {
    // Handle the addition logic here
    console.log('Selected Type:', selectedType);
    console.log('Selected POS:', selectedPOS);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Új elem hozzáadása</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography>Válassza ki, mit szeretne hozzáadni:</Typography>
          <Select
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Típus kiválasztása
            </MenuItem>
            <MenuItem value="businessUnit">Üzleti egység</MenuItem>
            <MenuItem value="counter">Pult</MenuItem>
            <MenuItem value="area">Terület</MenuItem>
            {availablePOS.length > 0 && <MenuItem value="pos">POS</MenuItem>}
          </Select>

          {selectedType === 'pos' && availablePOS.length > 0 && (
            <>
              <Typography>Válasszon egy POS-t:</Typography>
              <Select
                value={selectedPOS}
                onChange={(e) => setSelectedPOS(e.target.value)}
                displayEmpty
                fullWidth
              >
                <MenuItem value="" disabled>
                  POS kiválasztása
                </MenuItem>
                {availablePOS.map((pos, index) => (
                  <MenuItem key={index} value={pos.id}>
                    {pos.title}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Mégse
        </Button>
        <Button
          onClick={handleAdd}
          color="primary"
          disabled={!selectedType || (selectedType === 'pos' && !selectedPOS)}
        >
          Hozzáadás
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddNewTreeNodePopup;